import React from "react";
import { Space, Typography } from "antd";
import { formatDate, formatRelativeTime } from "../../utils/date";

const { Text } = Typography;

const RelativeBadge = ({ timestamp }) => (
  <span className="relative-badge">{formatRelativeTime(timestamp)}</span>
);

const CreatedAssignedCell = ({ record }) => (
  <div className="created-assigned-cell">
    <Space size={8} wrap>
      <Text strong>{formatDate(record.created_at)}</Text>
      <RelativeBadge timestamp={record.created_at} />
    </Space>
    <Space size={8} wrap className="assigned-row">
      <Text strong>
        {record.assign_epoch
          ? formatDate(record.assign_epoch)
          : "Not assigned"}
      </Text>
      {record.assign_epoch && (
        <RelativeBadge timestamp={record.assign_epoch} />
      )}
    </Space>
  </div>
);

export default CreatedAssignedCell;
